<template>
  <v-dialog
    v-model="dialog"
    transition="fade-transition"
    :fullscreen="selectFileType === 'application'"
    :width="selectFileType === 'application' ? null : 800"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" class="my-n2" :disabled="disabled">
        <ImagesIcon :filled="iconFilled" :disabled="disabled"/>
      </v-btn>
    </template>
    <template v-if="images && images.length > 0">
      <v-sheet
        tile
        flat
        color="transparent"
        :height="selectFileType === 'application' ? 'calc(100vh - 60px)' : null"
      >
        <PDFJSViewer
          v-if="selectFileType === 'application'"
          :url="String(needApiDomain ? apiDomain + '/' : '') + images[i]"
        />
        <v-img v-else :src="String(needApiDomain ? apiDomain + '/' : '') + images[i]" contain/>
      </v-sheet>
      <v-btn @click="dialog = false" absolute top right fab small dark class="mt-16 mr-n2">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn
        v-if="images.length > 1"
        @click="i === 0 ? (i = images.length - 1) : i--"
        absolute
        left
        fab
        small
        dark
        class="mt-16 mr-n2 arrow"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        v-if="images.length > 1"
        @click="i === images.length - 1 ? (i = 0) : i++"
        absolute
        right
        fab
        small
        dark
        class="mt-16 mr-n2 arrow"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <div class="d-flex justify-center dots">
        <v-btn
          v-for="(id, ii) in images.length"
          :key="'dot_' + ii"
          height="10"
          width="10"
          class="mx-1 my-2"
          :disabled="i === id - 1"
          @click="i = id - 1"
        />
      </div>
    </template>
  </v-dialog>
</template>

<script>
import ImagesIcon from './icons/ImagesIcon'
import {mapGetters} from 'vuex'
import PDFJSViewer from 'components/PDFJSViewer'

export default {
  name: 'ImageCarousel',
  components: {ImagesIcon, PDFJSViewer},
  props: {
    images: {
      type: Array,
      default: () => {
        return []
      },
    },
    needApiDomain: Boolean,
    iconFilled: Boolean,
    disabled: Boolean,
  },
  data: () => ({
    dialog: false,
    i: 0,
  }),
  computed: {
    ...mapGetters(['apiDomain']),
    selectFileType() {
      return this.images ? this.onCheckFileType(this.images[this.i]) : null
    },
  },
  methods: {
    onCheckFileType(value) {
      let result
      if (typeof value === 'string') {
        result = value.split('.')[1] === 'pdf' ? 'application' : 'image'
      } else {
        if (value && value.type)
          result = value.type.split('/')[0]
      }
      return result
    },
  },
}
</script>

<style scoped lang="scss">
.v-dialog {
  .v-btn {
    background-color: rgba(black, 0.65) !important;

    &:hover {
      background-color: rgba(black, 0.85) !important;
    }

    &.arrow {
      top: 43vh;
    }
  }

  .dots {
    position: absolute;
    bottom: 0;
    left: 0;

    .v-btn {
      min-width: auto;
      padding: 0 !important;
    }
  }
}
</style>
